/**
 * Service Worker Registration
 * Safely registers the service worker for caching
 */

(function() {
  'use strict';
  
  // Check if service workers are supported
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker not supported');
    return;
  }
  
  // Wait for page to load
  window.addEventListener('load', function() {
    registerServiceWorker();
  });
  
  function registerServiceWorker() {
    try {
      navigator.serviceWorker.register('/assets/service-worker.js', {
        scope: '/'
      })
      .then(function(registration) {
        console.log('Service Worker registered successfully:', registration.scope);
        
        // Check for updates
        registration.addEventListener('updatefound', function() {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', function() {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available
              showUpdateNotification();
            }
          });
        });
      })
      .catch(function(error) {
        console.log('Service Worker registration failed:', error);
      });
    } catch (error) {
      console.log('Service Worker registration error:', error);
    }
  }
  
  // Show update notification
  function showUpdateNotification() {
    // Only show if user hasn't dismissed it
    if (!localStorage.getItem('sw-update-dismissed')) {
      const notification = document.createElement('div');
      notification.className = 'sw-update-notification';
      notification.innerHTML = `
        <div style="
          position: fixed;
          bottom: 20px;
          right: 20px;
          background: #2B4A3E;
          color: white;
          padding: 15px 20px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          z-index: 10000;
          max-width: 300px;
          font-family: Arial, sans-serif;
        ">
          <div style="margin-bottom: 10px; font-weight: bold;">Update Available</div>
          <div style="margin-bottom: 15px; font-size: 14px;">A new version is available. Refresh to update.</div>
          <div style="display: flex; gap: 10px;">
            <button onclick="location.reload()" style="
              background: white;
              color: #2B4A3E;
              border: none;
              padding: 8px 16px;
              border-radius: 4px;
              cursor: pointer;
              font-weight: bold;
            ">Update Now</button>
            <button onclick="dismissUpdateNotification()" style="
              background: transparent;
              color: white;
              border: 1px solid white;
              padding: 8px 16px;
              border-radius: 4px;
              cursor: pointer;
            ">Dismiss</button>
          </div>
        </div>
      `;
      
      document.body.appendChild(notification);
    }
  }
  
  // Dismiss update notification
  window.dismissUpdateNotification = function() {
    localStorage.setItem('sw-update-dismissed', 'true');
    const notification = document.querySelector('.sw-update-notification');
    if (notification) {
      notification.remove();
    }
  };
  
  // Handle service worker messages
  navigator.serviceWorker.addEventListener('message', function(event) {
    if (event.data && event.data.type === 'CACHE_UPDATED') {
      console.log('Cache updated:', event.data.payload);
    }
  });
  
})();
